export var StorageAlertLevel;
(function (StorageAlertLevel) {
    /**
     * Storage alert level for new user since they have 100% storage available
     */
    StorageAlertLevel["None"] = "None";
    /**
     * For <80% storage usage
     */
    StorageAlertLevel["Default"] = "Default";
    /**
     * For >80% and <100% storage usage
     */
    StorageAlertLevel["Warning"] = "Warning";
    /**
     * For 100% storage usage
     */
    StorageAlertLevel["Full"] = "Full";
    /**
     * For >100% storage usage. User can exceed storage in certain conditions
     */
    StorageAlertLevel["Over"] = "Over";
    // Additional enums for USQ states
    /**
     * For >80% and <90% storage usage
     */
    StorageAlertLevel["WarningUSQ"] = "WarningUSQ";
    /**
     * For >90% and <100% storage usage
     */
    StorageAlertLevel["CriticalUSQ"] = "CriticalUSQ";
})(StorageAlertLevel || (StorageAlertLevel = {}));
//# sourceMappingURL=StorageAlertLevel.js.map